import defined from "../../../../util/defined";
import getENV from "../../../../util/getENV";
import useSmartContract from "../../useSmartContract";

export default function useObituary() {
    //console.log('>>> useObituary')
    const { modules: { obituary: { contract } } } = getENV();
    const { contract: obituary } = useSmartContract(contract);
    return { obituary }
}